import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setIdVerificationActions,
  SetTheIdVerifycationActions,
  SetActiveTabs,
  setIdVerificationActionsCreate,
  setIdVerificationActionsEdit,
  setIDverifycationanotherapidatasActions, ////id verification another get api list
  setTheOtherpARTYaPIaCTIONS, ////Third party API
  setBankDetailsId, //--bank ids
  setThePANCARDeportActions,
  setThePANCARDSUBMITeportActions,
  SetActionsBasicFormsDetails,
  SetAddressForm,
  setThPanVerifyCounts,
  setPreviousDataFetchActions,
  setThePanFrontCOunt,
  setTHnUMBERSRESPONSES,
  SetIdVeriications, ///- setthe id , for the put method
  setTheGrossSalarayAmount,
  SetJObofferCall,
  setThePANCARDotpResponsiveDatas,
  setTheSumbitOtpFormsAadhar_verified
} from "../../../Redux/Slice";
import Swal from "sweetalert2";
import { Grid, Typography, Button } from "@material-ui/core";
import { useDropzone } from "react-dropzone";
import UploadImgae from "../../../Assets/AppComponent/Image_Upload.png";
import Uploadimage2 from "../../../Assets/AppComponent/Uploadimage2.webp";
import { toast } from "react-toastify";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import $ from "jquery";
import { UNSAFE_DataRouterContext } from "react-router-dom";
import ImageCropper from "../ReactcropOverall/Imagecrop";
import { PresentUrl } from "../../../text/apidata";
import axios from "axios";
import { store } from "../../../Redux/Store";
import correctIcons from "../../../Assets/AppComponent/icons/Group 359.svg";
import banknotVerifed from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-17 (1).svg";

import BankAsVerifyed from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-16.svg";
import { Downloads_doc } from "./Downloads_doc";

const IDverify = () => {
  const state = useSelector((state) => state);
  const dispatch = useDispatch();
  const Swal = require("sweetalert2");
  const formdata = new FormData();
  const CreateEdForm = new FormData();
  //aadhar_id
  //console.log(state.idverfiyicationapidatas.Idverificationanotherapidatas.aadhar_id.replace(/\s/g, ''),"adnsndansdlka" );
  const initialState = {
    aadhar_number: "",
    aadharback_id: "",
    aadharfront_id: "",
    // pan_number: "",
    pan_number: "",

    pan_id: "",
    aadhar_verified: "",
    pan_verified: false,
    pan: "",

    is_id_verification: "",
    pan_front_count: 0,
    pan_verify_count: 0, /// pan verifedcounts ,
  };
  const [data, setDatas] = useState(initialState);

  const [police_verfiy, setpolice_verify] = useState({
    police_verify_remarks: "",
    is_police_verification: false,
  })

  const [docErr, setDocErr] = useState("");
  const [remarksErr, setRemarksErr] = useState("");

  const [Approvel, setApprovel] = useState(false);
  const [AadharErr, setAAdharErr] = useState("");
  const [AAdhaBackERR, setAadhaRBAckErr] = useState("");
  const [PanImaErr, setPanIMErr] = useState("");
  const [AadhaFronErr, setAsdharFrerro] = useState("");
  const [PanNuErr, setPanErr] = useState("");
  const [count, setCount] = useState(0); // Initialize count with one_mark
  const Panfromdata = new FormData();
  const [Panverified, setPanverifed] = useState(false)
  const incrementCount = () => {
    setCount(count + 1);
    // dispatch(setThPanVerifyCounts(count + 1));
  };
  const [pancardFiles, setpancardfile] = useState()

  const [pan_verifiedCoun, setpanCount] = useState(0); // Initialize count with one_mark
  const fileInputRef = useRef()
  const fileInputRef_police = useRef()
  const [forindex, setforindex] = useState();


  const style = {
    color:
      data.pan_number != ""
        &&

        state.PANCARDthephoneotp.PANCARDDATA == true ||
        data.pan_verified == true
        ? "green"
        : "#ddd",
    fontSize: "24px",
    fontWeight: "900",
  };

  ////---present-----url


  const [PresentUrls, setPresentUrls] = useState([]);
  const [presenturlInUrl, seturlandfile] = useState({
    file: "",
    url: null
  })


  const [whatsApp, setWhatsApp] = useState(false);

  //--On--Drop--A ---files
  const [ImageField, setImageField] = useState({
    frontImage: [],
    backImage: [],
    panImag: [],
  });

  const [ImageFieldUrl, setImageFieldurl] = useState({
    frontImage: [],
    backImage: [],
    panImag: [],
  });
  const [ImageSEND, setImageSend] = useState(false);
  const [AAfrontSt, setAARDHARFro] = useState(false);
  const [BackAadharIms, setaadhIms] = useState(false);
  const [PanImgStat, setPaImsStar] = useState(false);

  const [urlsign, setUrlsign] = useState();

  const [urlpan, seturlpan] = useState();

  const [imgfile2, setimgfile2] = useState();
  const [imgfile3, setimgfile3] = useState();
  const [file, setFile] = useState([]);
  const [crop, setCrop] = useState();
  const [imgfile, setimgfile] = useState();
  const [imgtype, setimgtype] = useState();
  const [imgsrc, setImgsrc] = useState();
  const imgRef = useRef(null);
  const [url, setUrl] = useState();
  // console.log(url);
  const [alert, setalert] = useState(false);
  const [CroppImageView, setCroppImageView] = useState(false);
  const muiltiplefiles = {
    file1: "",
    file2: "",
    file3: "",
  };
  const [idverificationsID, setdVerifications] = useState(false);

  const [numberoffiles, setfiles] = useState(muiltiplefiles);
  const [CroppImageViewCount, setCroppImageViewCount] = useState(0);


  const [url_police, steurl_police] = useState(null);
  const [policedoc, setpolicedoc] = useState(false);
  const [police_docfirlurl, setpolice_docfileurl] = useState({
    police_doc_url: ""
  })
  const [Police_doc_err, setpolice_doc_err] = useState("");
  const [Police_remarkserr, setpolice_remarkserr] = useState("");

  const [police_docFile, setPoliceDocFile] = useState(null)
  ////--- previous--value will be display in the aadhar front and back side image ----



  useEffect(() => {
    if (
      state.OtherPartyApiForPAn.OtherPartyPans != undefined &&
      state.OtherPartyApiForPAn.OtherPartyPans != null
    ) {
      setDatas({
        ...data,
        pan_number:
          state.OtherPartyApiForPAn.OtherPartyPans != undefined &&
            state.OtherPartyApiForPAn.OtherPartyPans != null &&
            state.OtherPartyApiForPAn.OtherPartyPans.pan_no != "" &&
            state.OtherPartyApiForPAn.OtherPartyPans.pan_no != null
            ? state.OtherPartyApiForPAn.OtherPartyPans.pan_no
            : "",
      });
    }
  }, [, state.OtherPartyApiForPAn.OtherPartyPans]);
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setpolice_verify((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value.toUpperCase(),
    }));

    // clear error dynamically
    if (name === "police_verify_remarks") setpolice_remarkserr("");
  };


  const cancel3 = (e) => {
    setalert(true);
    seturlpan("");
    setfiles({
      ...numberoffiles,
      file3: "",
    });
    setDatas({
      ...data,
      pan_number: ""
    })
    setPresentUrls([]);
    seturlandfile({
      ...presenturlInUrl,
      url: null
    })
  };

  useEffect(() => {
    if (
      state.FormsIDList.Idverify != undefined &&
      state.FormsIDList.Idverify != "" &&
      state.FormsIDList.ActiveTabs == 3
    ) {
      let payload = {
        Retieveid: state.FormsIDList.Idverify,
      };
      dispatch(setIdVerificationActions(payload));
    }
  }, [state.FormsIDList.ActiveTabs]);

  // useEffect(() => {
  //   if (
  //     state.FormsIDList.BasicFormID != undefined &&
  //     state.FormsIDList.ActiveTabs == 3
  //   ) {
  //     let payload = {
  //       Retieveid: state.FormsIDList.BasicFormID,
  //     };
  //     dispatch(SetActionsBasicFormsDetails(payload));
  //   }
  //   if (
  //     state.FormsIDList.AddressId != "" &&
  //     state.FormsIDList.AddressId != undefined &&
  //     state.FormsIDList.ActiveTabs == 3
  //   ) {
  //     let payload = {
  //       Retieveid: state.FormsIDList.AddressId,
  //     };

  //     dispatch(SetAddressForm(payload));
  //   }
  // }, [state.FormsIDList.ActiveTabs]);

  // useEffect(() => {
  //   if (
  //     state.FormsSDETAILS.BasciForm.id != undefined &&
  //     // state.FormsIDList.BasicFormID == state.FormsSDETAILS.BasciForm.id &&
  //     state.FormsSDETAILS.BasciForm.aadhar_front != null &&
  //     state.FormsIDList.BasicFormID != ""
  //   ) {
  //     if (state.FormsSDETAILS.BasciForm != null)
  //       setUrl(state.FormsSDETAILS.BasciForm.aadhar_front.media_url);
  //     setDatas({
  //       ...data,
  //       aadharfront_id:state.FormsSDETAILS.BasciForm?.aadhar_front?.media_url,
  //       aadhar_number: state.FormsSDETAILS.BasciForm.aadhar_number,
  //     });

  //     dispatch(
  //       setTHnUMBERSRESPONSES(
  //         state.FormsSDETAILS.BasciForm.aadhar_number != null
  //           ? state.FormsSDETAILS.BasciForm.aadhar_number
  //           : ""
  //       )
  //     );
  //   }
  // }, [state.FormsSDETAILS.BasciForm, state.FormsIDList.ActiveTabs]);
  //  console.log(url ,"ieuroiwueroweiru");

  // useEffect(() => {
  //   if (
  //     state.AddressForms.AddressForm.id != undefined &&
  //     state.AddressForms.AddressForm.id == state.AddressForms.AddressForm.id &&
  //     state.AddressForms.AddressForm != "" &&
  //     state.AddressForms.AddressForm.aadhar_back != null &&
  //     state.AddressForms.AddressForm.aadhar_back != undefined
  //   ) {
  //     if (state.AddressForms.AddressForm != null)
  //       setUrlsign(state.AddressForms.AddressForm.aadhar_back.media_url);
  //     setDatas({
  //       ...data,
  //       aadharback_id:state.AddressForms.AddressForm.aadhar_back.media_url
  //     })
  //     // setUrlsign(state.FormsSDETAILS.BasciForm.aadharback_id.media_url);
  //   }
  // }, [state.AddressForms.AddressForm, state.FormsIDList.ActiveTabs]);
  console.log(state.IdverificationName.IdVerifycationData, "state.IdverificationName.IdVerifycationData", state.FormsIDList.Idverify);

  useEffect(() => {
    if (state.FormsIDList.Idverify == "") {
      dispatch(setThPanVerifyCounts(0));
    }
    if (
      state.FormsIDList.Idverify != "" &&
      state.FormsIDList.Idverify ==
      state.IdverificationName.IdVerifycationData.id &&
      state.IdverificationName.IdVerifycationData != undefined
    ) {

      setDatas({
        ...data,
        aadhar_number:
          state.IdverificationName.IdVerifycationData.aadhar_number,
        aadharback_id:
          state.IdverificationName.IdVerifycationData.aadharback_id != null &&
            state.IdverificationName.IdVerifycationData.aadharback_id != undefined
            ? state.IdverificationName.IdVerifycationData.aadharback_id
              .media_url
            : "",
        aadharfront_id:
          state.IdverificationName.IdVerifycationData.aadharfront_id !=
            undefined &&
            state.IdverificationName.IdVerifycationData.aadharfront_id != null
            ? state.IdverificationName.IdVerifycationData.aadharfront_id
              .media_url
            : state.FormsSDETAILS.BasciForm?.aadhar_front?.media_url,
        pan_number:
          state.IdverificationName.IdVerifycationData.pan_number != null
            ? state.IdverificationName.IdVerifycationData.pan_number
            : "",
        // pan_id: state.IdverificationName.IdVerifycationData.pan_id.media_url,
        aadhar_verified:
          state.IdverificationName.IdVerifycationData.aadhar_verified,
        pan_verified: state.IdverificationName.IdVerifycationData.pan_verified,
      });
      setUrlsign(
        state.IdverificationName.IdVerifycationData.aadharback_id != null &&
          state.IdverificationName.IdVerifycationData.aadharback_id != undefined
          ? state.IdverificationName.IdVerifycationData.aadharback_id
            .media_url
          : ""
      )
      dispatch(setThePANCARDotpResponsiveDatas(state.IdverificationName.IdVerifycationData.pan_verified))

      dispatch(
        setTHnUMBERSRESPONSES(
          state.IdverificationName.IdVerifycationData.aadhar_number != null
            ? state.IdverificationName.IdVerifycationData.aadhar_number
            : ""
        )
      );

      setpolice_verify({
        ...police_verfiy,
        police_verify_remarks: state.IdverificationName.IdVerifycationData.police_verify_remarks,
        is_police_verification: state.IdverificationName.IdVerifycationData.is_police_verification,

      })
      if (
        state.IdverificationName.IdVerifycationData != undefined &&
        state.IdverificationName.IdVerifycationData.police_verification_document_id != null &&
        state.IdverificationName.IdVerifycationData.police_verification_document_id != undefined &&
        state.IdverificationName.IdVerifycationData.police_verification_document_id.media_url != null &&
        state.IdverificationName.IdVerifycationData.police_verification_document_id.media_url !=
        undefined
      ) {
        setpolicedoc(false)
        setpolice_docfileurl({
          ...police_docfirlurl,
          police_doc_url: state.IdverificationName.IdVerifycationData.police_verification_document_id.media_url
        })
        steurl_police(state.IdverificationName.IdVerifycationData.police_verification_document_id.media_url); //---pan--image
      }
      else if (state.IdverificationName.IdVerifycationData.police_verification_document_id == null) {
        setpolice_docfileurl({
          ...police_docfirlurl,
          police_doc_url: null,
        })
        steurl_police(null); //---police doc--image
        setpolicedoc(false)

      }


      if (state.aadharsentSubmitthephoneotp.SubmitValues == false) {
        dispatch(setTheSumbitOtpFormsAadhar_verified(state.IdverificationName.IdVerifycationData.aadhar_verified))

      }



      if (
        state.IdverificationName.IdVerifycationData.finance_data != undefined &&
        state.IdverificationName.IdVerifycationData.finance_data != null &&
        state.IdverificationName.IdVerifycationData.finance_data[0]
      ) {
        dispatch(
          setThPanVerifyCounts(
            state.IdverificationName.IdVerifycationData.finance_data[0]
              .pan_verify_count
          )

        );

        setPanverifed(state.IdverificationName.IdVerifycationData.finance_data[0].pan_verified)
        // setCount(            state.IdverificationName.IdVerifycationData.finance_data[0]
        //   .pan_verify_count)
        dispatch(
          setThePanFrontCOunt(
            state.IdverificationName.IdVerifycationData.finance_data[0]
              .pan_front_count
          )
        );
      }

      //  console.log(state.BankDetails.Bankdata.bank_id.media_url, "bancksdas");
      // console.log(
      //   state.IdverificationName.IdVerifycationData.aadharfront_id !=
      //     undefined &&
      //     state.IdverificationName.IdVerifycationData.aadharfront_id != null
      //     ? state.IdverificationName.IdVerifycationData.aadharfront_id.media_url
      //     : "",
      //   "media_url"
      // );
      if (
        state.EmployeeProfile.EmployeeProfileList != "" &&
        state.EmployeeProfile.EmployeeProfileList.job_description != null &&
        state.EmployeeProfile.EmployeeProfileList != undefined &&
        !state.EmployeeProfile.EmployeeProfileList.is_pending &&
        !state.EmployeeProfile.EmployeeProfileList.is_pending &&
        !state.EmployeeProfile.EmployeeProfileList.job_description !=
        undefined &&
        state.EmployeeProfile.EmployeeProfileList.job_description.letter_id !=
        undefined
      ) {
        setApprovel(true);
      }

      if (
        state.EmployeeProfile.EmployeeProfileList != "" &&
        state.EmployeeProfile.EmployeeProfileList.is_id_verification != null &&
        state.EmployeeProfile.EmployeeProfileList.is_id_verification !=
        undefined
      ) {
        setdVerifications(
          state.EmployeeProfile.EmployeeProfileList.is_id_verification
        );
      }

      if (
        state.EmployeeProfile.EmployeeProfileList != "" &&
        state.EmployeeProfile.EmployeeProfileList.whatsapp_verify != null &&
        state.EmployeeProfile.EmployeeProfileList.whatsapp_verify != undefined
      ) {
        setWhatsApp(state.EmployeeProfile.EmployeeProfileList.whatsapp_verify);
      }

      if (
        state.IdverificationName.IdVerifycationData != undefined &&
        state.IdverificationName.IdVerifycationData.aadharback_id != null &&
        state.IdverificationName.IdVerifycationData.aadharfront_id != null &&
        state.IdverificationName.IdVerifycationData.aadharback_id.media_url !=
        undefined
      ) {
        setImageFieldurl({
          ...ImageFieldUrl,
          panImag:
            state.IdverificationName.IdVerifycationData.pan_id != undefined &&
              state.IdverificationName.IdVerifycationData.pan_id.media_url !=
              undefined
              ? state.IdverificationName.IdVerifycationData.pan_id.media_url
              : "",
        });
      }

      if (
        state.IdverificationName.IdVerifycationData != undefined &&
        state.IdverificationName.IdVerifycationData.pan_id != null &&
        state.IdverificationName.IdVerifycationData.pan_id != undefined &&
        state.IdverificationName.IdVerifycationData.pan_id.media_url != null &&
        state.IdverificationName.IdVerifycationData.pan_id.media_url !=
        undefined
      ) {
        seturlandfile({
          ...presenturlInUrl,
          url: state.IdverificationName.IdVerifycationData.pan_id.media_url
        })
        seturlpan(state.IdverificationName.IdVerifycationData.pan_id.media_url); //---pan--image
        setPaImsStar(false)
      }

      if (
        state.IdverificationName.IdVerifycationData.aadharfront_id != null &&
        state.IdverificationName.IdVerifycationData.aadharback_id != null &&
        state.IdverificationName.IdVerifycationData.aadharfront_id !=
        undefined &&
        state.IdverificationName.IdVerifycationData.aadharback_id !=
        undefined &&
        state.IdverificationName.IdVerifycationData.aadharback_id !=
        undefined &&
        state.IdverificationName.IdVerifycationData.aadharback_id.media_url !=
        undefined &&
        state.IdverificationName.IdVerifycationData.aadharback_id.media_url !=
        null
      ) {
        setImageFieldurl({
          ...ImageFieldUrl,
          backImage:
            state.IdverificationName.IdVerifycationData.aadharback_id.media_url,
          frontImage:
            state.IdverificationName.IdVerifycationData.aadharfront_id
              .media_url,
          //  panImag: state.EmployeeProfile.EmployeeProfileList.pan_id.media_url,
        });
      }
    }
  }, [
    state.IdverificationName.IdVerifycationData,
    state.FormsIDList.Idverify,
    state.FormsIDList.ActiveTabs,
  ]);

  const HandleChanges = (e) => {
    if (e.target.name == "aadhar_number") {
      setDatas((prev) => {
        return {
          ...prev,
          [e.target.name]: e.target.value.slice(0, 12),
        };
      });
    }
    if (e.target.name == "pan_number") {
      setDatas((prev) => {
        return {
          ...prev,
          [e.target.name]: e.target.value.slice(0, 10),
        };
      });
    }
  };

  const selectedImage = (e) => {
    console.log(e.target.files[0]);
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.addEventListener("load", () => setImgsrc(reader.result));
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  const setCompletedCrop = async (c) => {
    const url = await getCroppedImg(imgRef.current, c, "newfile.jpeg");
  };
  const onImageLoaded = (image) => {
    // imgRef = image;
    imgRef.current = image;
  };

  ///-------------------files-------------------
  const handleFiles = (e) => {
    selectedImage(e);
    setCroppImageViewCount(1);
    setforindex(1)
    setpolicedoc(true)
    setpolice_doc_err("");
    setPoliceDocFile(e);

    setCroppImageView(true);
    setalert(true);
    const file = e.target.files[0];

    const allowedTypes = ["image/jpeg", "image/png", "image/svg+xml"];
    const maxSize = 10 * 1024 * 1024; // 3MB in bytes
    const MIN_DIMENSION = 150;

    if (file && allowedTypes.includes(file.type)) {
      if (file.size > maxSize) {
        setCroppImageView(false);
        toast.error("File size exceeds 10MB. Please upload a smaller image.");
      } else {
        const reader = new FileReader();
        reader.addEventListener("load", () => {
          const imageElement = new Image();
          const imageUrl = reader.result?.toString() || "";
          imageElement.src = imageUrl;

          imageElement.addEventListener("load", (imgEvent) => {
            const { naturalWidth, naturalHeight } = imgEvent.currentTarget;

            if (naturalWidth < MIN_DIMENSION || naturalHeight < MIN_DIMENSION) {
              toast.error("Image must be at least 150 x 150 pixels.");
              setCroppImageView(false);
              return;
            }

          });
        });
        reader.readAsDataURL(file); // Read the file as a data URL
      }
    } else {
      setCroppImageView(false);
      toast.error("Please upload an image file (jpg, jpeg, png, svg).");
    }

  };
  const handleFiles2 = (e) => {
    selectedImage(e);
    setCroppImageViewCount(2);
    setCroppImageView(true);

    setalert(true);
  };

  const handleFiles3 = (e) => {
    setCroppImageViewCount(3);
    setCroppImageView(true);
    setImageSend(true);
    setpancardfile(e);
    setPresentUrls([]);
    setalert(true);
    setforindex(0)

    const file = e.target.files[0];

    const allowedTypes = ["image/jpeg", "image/png", "image/svg+xml"];
    const maxSize = 10 * 1024 * 1024; // 3MB in bytes
    const MIN_DIMENSION = 150;

    if (file && allowedTypes.includes(file.type)) {
      if (file.size > maxSize) {
        setCroppImageView(false);
        toast.error("File size exceeds 10MB. Please upload a smaller image.");
      } else {
        const reader = new FileReader();
        reader.addEventListener("load", () => {
          const imageElement = new Image();
          const imageUrl = reader.result?.toString() || "";
          imageElement.src = imageUrl;

          imageElement.addEventListener("load", (imgEvent) => {
            const { naturalWidth, naturalHeight } = imgEvent.currentTarget;

            if (naturalWidth < MIN_DIMENSION || naturalHeight < MIN_DIMENSION) {
              toast.error("Image must be at least 150 x 150 pixels.");
              setCroppImageView(false);
              return;
            }

            selectedImage(e);
            setPanErr("");
            setPanIMErr("");
          });
        });
        reader.readAsDataURL(file); // Read the file as a data URL
      }
    } else {
      setCroppImageView(false);
      toast.error("Please upload an image file (jpg, jpeg, png, svg).");
      // e.target.value = ""; // Clear the file input
    }
  };

  console.log(state.aadharsentSubmitthephoneotp.SubmitValues, "state.aadharsentSubmitthephoneotp.SubmitValues");

  const updateAvatar = (imgSrc) => {
    if (CroppImageViewCount == 1) {
      fileInputRef_police.current.value = imgSrc;

    }
    else if (CroppImageViewCount == 1) {
      fileInputRef.current.value = imgSrc;

    }
  };




  function getCroppedImg(imageRef, crop, fileName) {
    const canvas = document.createElement("canvas");
    const scaleX = imageRef.current.naturalWidth / imageRef.current.width;
    const scaleY = imageRef.current.naturalHeight / imageRef.current.height;
    canvas.width = crop.width * scaleX;
    canvas.height = crop.height * scaleY;
    const ctx = canvas.getContext("2d");

    ctx.drawImage(
      imageRef.current,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width * scaleX,
      crop.height * scaleY
    );


    return new Promise((resolve, reject) => {
      canvas.toBlob((blob) => {
        if (!blob) {
          console.error("Canvas is empty");
          return;
        }
        const croppedFile = new File([blob], fileName, {
          type: "image/jpeg",
        });
        // setCroppImageView(false)
        if (croppedFile) {
          setTimeout(() => {
            setCroppImageView(false)

          }, 0);
        }
        var file = croppedFile;

        if (
          CroppImageViewCount == 3

        ) {

          setFile(croppedFile);
          var reader = new FileReader();
          reader.onloadend = function () {
            setUrl(reader.result);
          };
          reader.readAsDataURL(file);
          setimgfile3(croppedFile);
          setPaImsStar(true);

          setfiles({
            ...numberoffiles,
            file3: croppedFile,
          });

          var file = croppedFile;
          var reader = new FileReader();
          reader.onloadend = function () {
            seturlpan(reader.result);

            // pan_front_count

            ///separate call for the Pan card as third party APi
          };

          reader.readAsDataURL(file);

          if (croppedFile) {

            const generateRandomNumber = (digits = 12) => {
              const min = 10 ** (digits - 1);
              const max = 10 ** digits;
              return Math.floor(min + Math.random() * (max - min));
            };



            const createPresentData = (croppedFile) => {
              const randomNumber = generateRandomNumber();
              const formattedFilename = `onboarding/pan/pan${randomNumber}.${croppedFile.type.split('/')[1]}`; // Use the file's extension
              const Presentdata = {
                multiple_files: [
                  {
                    filename: formattedFilename,
                    file_type: croppedFile.type,
                  },
                ],
              };

              return Presentdata;
            };


            const Presentdata = createPresentData(croppedFile);
            axios({
              url: PresentUrl,
              method: 'post',
              data: Presentdata,
              headers: {
                Authorization:
                  "Bearer " + store.getState().users.UserData.session.token,
              },
            })
              .then((response) => {
                const uploadedFiles = response.data.data;
                const newUrls = uploadedFiles.map(file => ({
                  url: file, // Adjust this based on the actual response
                  type: croppedFile.type,
                  putfiles: croppedFile
                }));
                setPresentUrls(prevUrls => {
                  const updatedUrls = [...prevUrls];
                  updatedUrls[forindex] = newUrls[0];
                  return updatedUrls;
                }); seturlandfile({
                  url: String(response.data.data).split("?")[0],

                })

              })
              .catch((error) => {
                console.error('Error uploading files:', error);
              });


            Panfromdata.append("aadhar_card", croppedFile);

            const payload = {
              fromdata: Panfromdata,
              count: count
            };
            dispatch(setTheOtherpARTYaPIaCTIONS(payload));
            dispatch(setThePanFrontCOunt(state.OnboardngCounts.pan_front_count + 1))


          }
        }
        if (
          CroppImageViewCount == 1

        ) {

          var reader = new FileReader();
          reader.onloadend = function () {
            setUrl(reader.result);
          };
          reader.readAsDataURL(file);

          var file = croppedFile;
          var reader = new FileReader();
          reader.onloadend = function () {
            steurl_police(reader.result);
          };

          reader.readAsDataURL(file);

          if (croppedFile) {

            const generateRandomNumber = (digits = 12) => {
              const min = 10 ** (digits - 1);
              const max = 10 ** digits;
              return Math.floor(min + Math.random() * (max - min));
            };


            const createPresentData = (croppedFile) => {
              const randomNumber = generateRandomNumber();
              const formattedFilename = `onboarding/police_verification/police_verification${randomNumber}.${croppedFile.type.split('/')[1]}`; // Use the file's extension
              const Presentdata = {
                multiple_files: [
                  {
                    filename: formattedFilename,
                    file_type: croppedFile.type,
                  },
                ],
              };

              return Presentdata;
            };


            const Presentdata = createPresentData(croppedFile);
            axios({
              url: PresentUrl,
              method: 'post',
              data: Presentdata,
              headers: {
                Authorization:
                  "Bearer " + store.getState().users.UserData.session.token,
              },
            })
              .then((response) => {
                const uploadedFiles = response.data.data;
                const newUrls = uploadedFiles.map(file => ({
                  url: file, // Adjust this based on the actual response
                  type: croppedFile.type,
                  putfiles: croppedFile
                }));
                setPresentUrls(prevUrls => {
                  const updatedUrls = [...prevUrls];
                  updatedUrls[forindex] = newUrls[0];
                  return updatedUrls;
                }); setpolice_docfileurl({
                  police_doc_url: String(response.data.data).split("?")[0],

                })

              })
              .catch((error) => {
                console.error('Error uploading files:', error);
              });


          }
        }
        resolve(croppedFile);
      }, "image/jpeg");
    });
  }

  console.log(data, "PresentUrls data", PanImgStat, policedoc);


  ///========Next-------------------------
  const HandleNext = () => {
    var a = 0;
    var b = 0;
    if (
      state.NumberCounts.Editable == 1 &&
      state.EmployeeProfile.EmployeeProfileList != undefined &&
      state.EmployeeProfile.EmployeeProfileList != null &&
      state.EmployeeProfile.EmployeeProfileList.bank_details != null &&
      state.EmployeeProfile.EmployeeProfileList.bank_details != undefined &&
      state.EmployeeProfile.EmployeeProfileList.id != undefined &&
      state.EmployeeProfile.EmployeeProfileList.bank_details.id != undefined
    ) {
      dispatch(
        setBankDetailsId(
          state.EmployeeProfile.EmployeeProfileList.bank_details.id
        )
      );
    }


    const fetchUploadFiles = async () => {
      await Promise.all(PresentUrls.map(async (item) => {
        try {
          if (item != undefined && item != null) {

            const response = await fetch(item.url, {
              method: 'PUT',
              headers: {
                'Content-Type': item.type,
                "x-amz-acl": "public-read"
              },
              body: item.putfiles,
            });

            if (!response.ok) {
              throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const data = await response.json();
            console.log('Files uploaded successfully:', data);
            setUrlsign(presenturlInUrl.url);
            setpolice_docfileurl(police_docfirlurl?.police_doc_url);
            // setPresentUrls([]);

          }
        } catch (error) {
          console.error('Error uploading files:', error);
        }
      }));
    };


    CreateEdForm.append(
      "data",
      JSON.stringify({
        aadhar_number: data.aadhar_number,
        pan_number: data.pan_number,
        is_id_verification: state.aadharsentSubmitthephoneotp.SubmitValues,
        pan_front_count: state.OnboardngCounts.pan_front_count,
        pan_verify_count: state.OnboardngCounts.pan_verify_count,
        pan_verified: state.PANCARDthephoneotp.PANCARDDATA,
        timeline_id:
          state.BasicFormCreated.BasciFormCreate == ""
            ? state.EmployeeProfile.EmployeeProfileList.id
            : state.BasicFormCreated.BasciFormCreate,
        aadhar_front: data.aadharfront_id,
        aadhar_back: data.aadharback_id
      })
    );

    let CreatedRawDatas = {
      aadhar_number: data.aadhar_number,
      pan_number: data.pan_number,
      is_id_verification: state.aadharsentSubmitthephoneotp.SubmitValues,
      pan_front_count: state.OnboardngCounts.pan_front_count,
      pan_verify_count: state.OnboardngCounts.pan_verify_count,
      pan_verified: state.PANCARDthephoneotp.PANCARDDATA,
      timeline_id:
        state.BasicFormCreated.BasciFormCreate == ""
          ? state.EmployeeProfile.EmployeeProfileList.id
          : state.BasicFormCreated.BasciFormCreate,
      pan: presenturlInUrl.url,
      aadhar_front: data.aadharfront_id,
      aadhar_back: data.aadharback_id,
      police_verification_document_id: police_docfirlurl?.police_doc_url

    }

    if (state.FormsIDList.Idverify == "") {
      CreateEdForm.append("pan", numberoffiles.file3);




      if (state.NumberCounts.Editable != 1) {



        if (data.aadhar_number == "") {
          setAAdharErr("*Aadhar Number is required");
          a = 1;
        }
      }
      if (data.aadharfront_id == "") {
        a = 1;
        toast.error("Please Upload Aadhar front image")
      }
      if (data.aadharback_id == "") {
        a = 1;
        toast.error("Please Upload Aadhar back image")
      }
      if (a == 0 && (PanImgStat == true || policedoc == true)) {
        fetchUploadFiles();

      }



      if (a == 0) {
        const payload = {
          CreateEdForm: CreatedRawDatas,
          // formdata: formdata,

          Retieveid: state.FormsIDList.Idverify,
          Verified_status:
            state.idverfiyicationapidatas.FirstAadharNumber !=
              state.idverfiyicationapidatas.SecondAadharNumbers
              ? 0
              : 1,
        };

        dispatch(setIdVerificationActionsCreate(payload));

      }
    }


    else if (
      state.FormsIDList.Idverify != ""

      //       ||
      //  data.pan_number != state.IdverificationName.IdVerifycationData?.pan_number ||
      //  Panverified != state.PANCARDthephoneotp.PANCARDDATA

      // ||
      //  (  
      //   urlpan != state.IdverificationName.IdVerifycationData.pan_id?.media_url)

    ) {

      if (data.aadhar_number == "") {
        setAAdharErr("*Aadhar Number is required");
        a = 1;
      }



      if (data.aadharfront_id == "") {
        a = 1;
        toast.error("Please Upload Aadhar front image")
      }
      if (data.aadharback_id == "") {
        a = 1;
        toast.error("Please Upload Aadhar back image")
      }

      console.log(a == 0 && (PanImgStat == true || policedoc == true), "suPOAIS ",);
      if (police_verfiy?.is_police_verification == true) {
        if (url_police == "" || !url_police) {
          a = 1;

          setpolice_doc_err("Please upload police verfication document");
        }
        if (police_verfiy?.police_verify_remarks == " " || !police_verfiy?.police_verify_remarks) {
          a = 1;
          setpolice_remarkserr("Remarks is required")
        }
      }

      if (a == 0 && (PanImgStat == true || policedoc == true)) {
        fetchUploadFiles();
      }
      //       if (a == 0 && b == 0) {

      //         if(
      //           data.pan_number != state.IdverificationName.IdVerifycationData?.pan_number ||
      //  Panverified != state.PANCARDthephoneotp.PANCARDDATA

      //       ||
      //        (  
      //         urlpan != state.IdverificationName.IdVerifycationData.pan_id?.media_url)
      //         ){ 

      //  let editrawDatas ={
      //   aadhar_number: data.aadhar_number,
      //   pan_number: data.pan_number,
      //   is_id_verification:state.aadharsentSubmitthephoneotp.SubmitValues , 
      //   pan_front_count: state.OnboardngCounts.pan_front_count,
      //   pan_verify_count: state.OnboardngCounts.pan_verify_count,
      //   pan_verified:state.PANCARDthephoneotp.PANCARDDATA,
      //   timeline_id:
      //     state.BasicFormCreated.BasciFormCreate == ""
      //       ? state.EmployeeProfile.EmployeeProfileList.id
      //       : state.BasicFormCreated.BasciFormCreate,
      //       pan:presenturlInUrl.url,
      //       aadhar_front:data.aadharfront_id,
      //       aadhar_back:data.aadharback_id,
      //                 police_verification_document_id:police_docfirlurl?.police_doc_url,

      // police_verify_remarks :police_verfiy?.police_verify_remarks,
      // is_police_verification :police_verfiy?.is_police_verification,

      //  }
      //         if (PanImgStat) {
      //           formdata.append("pan", numberoffiles.file3);
      //         }

      //         const payload = {
      //           CreateEdForm: editrawDatas,
      //           Retieveid: state.FormsIDList.Idverify,
      //           id: state.FormsIDList.Idverify,
      //           Verified_status:

      //             0,
      //         };
      //         dispatch(setIdVerificationActionsEdit(payload));

      //       } else if(
      //               (state.FormsIDList.Idverify != "" &&
      //         state.FormsIDList.Idverify ==
      //           state.IdverificationName.IdVerifycationData.id ) &&
      //       (data.pan_number ===
      //         state.IdverificationName.IdVerifycationData.pan_number !=
      //         null &&
      //         state.IdverificationName.IdVerifycationData.pan_number != undefined &&
      //         state.IdverificationName.IdVerifycationData.pan_number)
      //         &&
      //         Panverified == state.PANCARDthephoneotp.PANCARDDATA
      // &&
      //         urlpan === state.IdverificationName.IdVerifycationData.pan_id?.media_url
      //       ){
      //               dispatch(SetActiveTabs(4));

      //       }
      //       }

      if (a == 0 && b == 0) {
        // Extract police verification data for easier reading
        const policeDocUrl = police_docfirlurl?.police_doc_url;
        const existingPoliceDocUrl =
          state.IdverificationName.IdVerifycationData.police_verification_document_id?.media_url || null;

        const currentRemarks = police_verfiy?.police_verify_remarks || null;
        const existingRemarks = state.IdverificationName.IdVerifycationData?.police_verify_remarks || null;

        const currentVerificationStatus = police_verfiy?.is_police_verification || false;
        const existingVerificationStatus = state.IdverificationName.IdVerifycationData?.is_police_verification || false;

        // 🧠 Check for any change (PAN or Police Verification)
        const hasChanges =
          data.pan_number !== state.IdverificationName.IdVerifycationData?.pan_number ||
          Panverified !== state.PANCARDthephoneotp.PANCARDDATA ||
          urlpan !== state.IdverificationName.IdVerifycationData.pan_id?.media_url ||
          policeDocUrl !== existingPoliceDocUrl ||
          currentRemarks !== existingRemarks ||
          currentVerificationStatus !== existingVerificationStatus;


        if (hasChanges) {
          //  edit
          const editrawDatas = {
            aadhar_number: data.aadhar_number,
            pan_number: data.pan_number,
            // is_id_verification: state.aadharsentSubmitthephoneotp.SubmitValues,
            is_id_verification: true,
            // is_id_verification:state.IdverificationName.IdVerifycationData?.aadhar_verified ,
            pan_front_count: state.OnboardngCounts.pan_front_count,
            pan_verify_count: state.OnboardngCounts.pan_verify_count,
            pan_verified: state.PANCARDthephoneotp.PANCARDDATA,
            timeline_id:
              state.BasicFormCreated.BasciFormCreate == ""
                ? state.EmployeeProfile.EmployeeProfileList.id
                : state.BasicFormCreated.BasciFormCreate,
            pan: presenturlInUrl.url,
            aadhar_front: data.aadharfront_id,
            aadhar_back: data.aadharback_id,

            //  police verification fields
            police_verification_document_id: policeDocUrl,
            police_verify_remarks: currentRemarks,
            is_police_verification: currentVerificationStatus,
          };

          // append PAN image if needed
          if (PanImgStat) {
            formdata.append("pan", numberoffiles.file3);
          }

          const payload = {
            CreateEdForm: editrawDatas,
            Retieveid: state.FormsIDList.Idverify,
            id: state.FormsIDList.Idverify,
            Verified_status: 0,
          };

          dispatch(setIdVerificationActionsEdit(payload));
        } else if (
          // ✅ Match check for all PAN + Police fields
          state.FormsIDList.Idverify != "" &&
          state.FormsIDList.Idverify === state.IdverificationName.IdVerifycationData.id &&
          data.pan_number === state.IdverificationName.IdVerifycationData.pan_number &&
          Panverified === state.PANCARDthephoneotp.PANCARDDATA &&
          urlpan === state.IdverificationName.IdVerifycationData.pan_id?.media_url &&
          policeDocUrl === existingPoliceDocUrl &&
          currentRemarks === existingRemarks &&
          currentVerificationStatus === existingVerificationStatus
        ) {
          dispatch(SetActiveTabs(4));
        }
      }


    }






  };

  console.log(url_police, "poweuorwer", PresentUrls);


  return (
    <>
      <div className=" BodyContent" id="IdVerificationsID">
        <div className="card">
          <div className="card-body cards ">
            <div className="UserPoup">
              <div className="BeforForms">
                <div className="Form">
                  <div className="ModalHeader">
                    <div>
                      <span>ID Verification</span>
                    </div>
                  </div>
                  <div className="Modal-Body ModalForms">
                    <div className="row">


                      <div className="col-12 mt-3 mb-2">

                        <span style={{ color: "#234492", fontWeight: "550", fontSize: "17px" }}>Identity Proof Details</span>
                        <small
                          style={{
                            color: "red",
                            marginTop: "12px",
                            display: "block",
                          }}
                        >
                          Note:Upload the Pan Card picture, please.
                          Verify that the file is in the JPG, JPEG, or
                          PNG format and that its size is less than 10 MB.
                        </small>
                      </div>
                      <>
                        <div className="col-sm-3 mt-3">
                          <label htmlFor="aadhar-card" class="form-label">
                            Aadhaar Card Number
                          </label>
                          <span style={{ color: "red" }}>*</span>

                          <input
                            type="text"
                            class="form-control"
                            id="validationCustom01"
                            name="aadhar_number"
                            disabled={
                              state.NumberCounts.Editable == 1 &&
                                state.ClientBranchIDs.SUBROLE != 3
                                ? true
                                : false
                            }
                            value={
                              data?.aadhar_number
                                ? localStorage.getItem("aadharAccess") === "true"
                                  ? `**** ****  ${data.aadhar_number.slice(-4)}`
                                  : data.aadhar_number
                                : ""
                            }

                            readOnly
                            onChange={(e) => {
                              HandleChanges(e);
                            }}
                          />
                          <p className="Error" style={{ marginLeft: "-5px" }}>
                            {AadharErr}
                          </p>
                        </div>

                        {
                          state.NumberCounts.Editable == 1 ||
                            state.IdverificationName.IdVerifycationData.pan_number !=
                            undefined &&
                            state.IdverificationName.IdVerifycationData.pan_number !=
                            null &&
                            state.IdverificationName.IdVerifycationData.pan_number !=
                            "" ? (
                            <>
                              <div className="col-sm-3 mt-3">
                                <label htmlFor="aadhar-card" class="form-label">
                                  PAN Card Number
                                </label>


                                <input
                                  type="text"
                                  class="form-control"
                                  id="validationCustom01"
                                  autocomplete="off"
                                  name="pan_number"
                                  value={data.pan_number}
                                  disabled
                                  onChange={(e) => {
                                    HandleChanges(e);

                                    setPanErr("");
                                  }}
                                />

                                {/* <p className="Error" style={{ marginLeft: "-5px" }}>
                              {PanNuErr}
                            </p> */}
                              </div>
                              {data.pan_number != ""
                                &&
                                state.PANCARDthephoneotp.PANCARDDATA === false
                                && (data.pan_verified != true)
                                ?

                                <button
                                  className="ButtonCSS3  VerifyBtn"
                                  disabled={
                                    state.NumberCounts.Editable == 1
                                      ? state.ClientBranchIDs.SUBROLE == 3
                                        ? false
                                        : true // allow only when SUBROLE = 3
                                      : state.NumberCounts.Editable == 2
                                        ? state.NumberCounts.EmployeeFormFIll == true
                                          ? false
                                          : true // disable when true
                                        : null
                                  }
                                  onClick={(e) => {
                                    //                             if (
                                    //   state.OtherPartyApiForPAn.OtherPartyPans != undefined &&
                                    //   state.OtherPartyApiForPAn.OtherPartyPans != null
                                    // ) {
                                    // Panverifed();

                                    const aadhartop = {
                                      // data: state.OtherPartyApiForPAn.OtherPartyPans.pan_no,
                                      data: data.pan_number,

                                      //  count :count
                                      count: state.OnboardngCounts.pan_verify_count
                                      // data:data.pan_id

                                    };

                                    dispatch(setThePANCARDeportActions(aadhartop));
                                    // dispatch(setThPanVerifyCounts(count + 1));
                                    setPanverifed(false)

                                    // }
                                    incrementCount();

                                  }}
                                >

                                  Verify
                                </button>

                                :
                                null}

                              <span className="BankVerifiedImages">
                                {
                                  data.pan_number != ""
                                    &&

                                    state.PANCARDthephoneotp.PANCARDDATA == true ||
                                    data.pan_verified == true

                                    ?

                                    <img src={BankAsVerifyed} />
                                    :
                                    <img src={banknotVerifed} />
                                }
                              </span>

                            </>
                          ) : (
                            <>
                              {state.NumberCounts.Editable == 2 ? (
                                <>
                                  <div className="col-sm-3 mt-3">
                                    <label htmlFor="aadhar-card" class="form-label">
                                      PAN Card Number
                                    </label>

                                    <input
                                      type="text"
                                      class="form-control"
                                      id="validationCustom01"
                                      autocomplete="off"
                                      name="pan_number"
                                      value={data.pan_number}
                                      // readOnly={
                                      //   state.NumberCounts.Editable == 1 &&
                                      //   state.NumberCounts.Editable == 2 &&
                                      //   state.ClientBranchIDs.SUBROLE != 3
                                      //     ? true
                                      //     : false
                                      // }
                                      disabled
                                      onChange={(e) => {
                                        if (urlpan != null || urlpan != undefined || urlpan != "") {
                                          HandleChanges(e);
                                        }
                                        setPanErr("");
                                      }}
                                    />
                                    <p
                                      className="Error"
                                      style={{ marginLeft: "-5px" }}
                                    >
                                      {PanNuErr}
                                    </p>
                                  </div>
                                  {
                                    data.pan_number != ""
                                      &&
                                      state.PANCARDthephoneotp.PANCARDDATA === false
                                      && (data.pan_verified != true)
                                      ?
                                      <button
                                        className="ButtonCSS3  VerifyBtn"

                                        onClick={(e) => {

                                          const aadhartop = {
                                            data: data.pan_number,
                                            count: state.OnboardngCounts.pan_verify_count

                                          };

                                          dispatch(setThePANCARDeportActions(aadhartop));
                                          setPanverifed(false)
                                          incrementCount();

                                        }}
                                      >

                                        Verify
                                      </button>

                                      :
                                      null}

                                  <span className="BankVerifiedImages">
                                    {
                                      data.pan_number != ""
                                        &&

                                        state.PANCARDthephoneotp.PANCARDDATA == true ||
                                        data.pan_verified == true

                                        ?

                                        <img src={BankAsVerifyed} />
                                        :
                                        <img src={banknotVerifed} />
                                    }
                                  </span>
                                </>
                              ) : null}
                            </>



                          )}

                      </>



                    </div>

                    <>
                      <div className="row PhotoVerify ">

                        {state.NumberCounts.Editable == 1 &&
                          state.ClientBranchIDs.SUBROLE != 3 &&
                          state.IdverificationName.IdVerifycationData.id ==
                          state.FormsIDList.Idverify &&
                          state.IdverificationName.IdVerifycationData.pan_id !=
                          undefined &&
                          state.IdverificationName.IdVerifycationData.pan_id !=
                          null &&
                          state.IdverificationName.IdVerifycationData.pan_id
                            .media_url != null ? (
                          <>
                            <div className="col-6">
                              <label class="form-label-Header">
                                AADHAAR CARD (IMAGE)
                              </label>
                            </div>
                            <div className="col-6">
                              <label class="form-label-Header">
                                PAN CARD (IMAGE)
                              </label>
                            </div>
                          </>
                        ) : (
                          <>
                            {state.NumberCounts.Editable == 1 &&
                              state.ClientBranchIDs.SUBROLE != 3 &&
                              state.FormsIDList.Idverify ==
                              state.IdverificationName.IdVerifycationData.id ? (
                              <div className="col-12">
                                <label class="form-label-Header">
                                  Aadhaar card (Image)
                                </label>
                              </div>
                            ) : null}
                          </>
                        )}

                        {state.NumberCounts.Editable == 1 &&
                          state.ClientBranchIDs.SUBROLE != 3 &&
                          state.FormsIDList.Idverify ==
                          state.IdverificationName.IdVerifycationData.id &&
                          data.aadharfront_id != undefined &&
                          data.aadharfront_id != null ? (
                          <div className="col-3  aadhar ">
                            <div className="aadhar-card-input">
                              <img
                                src={data.aadharfront_id}
                                style={{
                                  border: "4px solid #234492",
                                  cursor: "pointer",
                                  borderRadius: "12px"
                                }}
                                onClick={(e) => {
                                  if (state.NumberCounts.Editable == 1) {

                                    window.open(data.aadharfront_id);
                                  }
                                }}
                              />
                            </div>
                            {/* </a> */}
                            <p htmlFor="aadhar-card" class="form-label">
                              Aadhaar Front Image
                              <Downloads_doc url={data.aadharfront_id} />
                            </p>
                          </div>
                        ) : null}

                        {state.NumberCounts.Editable == 1 &&
                          state.FormsIDList.Idverify ==
                          state.IdverificationName.IdVerifycationData.id &&
                          data.aadharback_id != undefined &&
                          data.aadharback_id != null &&
                          state.ClientBranchIDs.SUBROLE != 3 &&
                          data.aadharback_id != "" ? (
                          <div className="col-3   aadhar">
                            {/* <a href={data.aadharback_id} target="blank"> */}
                            <div className="aadhar-card-input">
                              <img
                                onClick={(e) => {
                                  if (state.NumberCounts.Editable == 1) {

                                    window.open(data.aadharback_id);
                                  }
                                }}
                                readOnly
                                src={data.aadharback_id}
                                style={{
                                  border: "4px solid #234492",
                                  cursor: "pointer",
                                  borderRadius: "12px"
                                }}
                              />
                            </div>
                            {/* </a> */}
                            <p htmlFor="aadhar-card" class="form-label">
                              Aadhaar back Image
                              <Downloads_doc url={data.aadharback_id} />
                            </p>
                          </div>
                        ) : null}
                        {state.NumberCounts.Editable == 1 &&
                          state.ClientBranchIDs.SUBROLE != 3 &&
                          state.FormsIDList.Idverify ==
                          state.IdverificationName.IdVerifycationData.id &&
                          state.IdverificationName.IdVerifycationData
                            .pan_number != undefined &&
                          state.IdverificationName.IdVerifycationData
                            .pan_number != null &&
                          state.IdverificationName.IdVerifycationData.pan_id !=
                          undefined &&
                          state.IdverificationName.IdVerifycationData.pan_id !=
                          null &&
                          state.IdverificationName.IdVerifycationData
                            .pan_number != "" ? (
                          <>
                            {state.IdverificationName.IdVerifycationData
                              .pan_id != undefined &&
                              state.IdverificationName.IdVerifycationData
                                .pan_id != null &&
                              state.IdverificationName.IdVerifycationData.pan_id
                                .media_url != null ? (
                              <>
                                <div className="col-6 mt-3 ">

                                  <div className="pan-card-input">
                                    <img
                                      onClick={(e) => {
                                        window.open(
                                          state.IdverificationName
                                            .IdVerifycationData.pan_id.media_url
                                        );
                                      }}
                                      src={
                                        state.IdverificationName
                                          .IdVerifycationData.pan_id.media_url
                                      }
                                      style={{
                                        border: "4px solid #234492",
                                        cursor: "pointer",
                                        borderRadius: "12px"
                                      }}
                                    />
                                  </div>
                                  <Downloads_doc url={state.IdverificationName.IdVerifycationData.pan_id.media_url} />

                                </div>
                              </>
                            ) : null}
                          </>
                        ) : null}
                      </div>
                    </>
                    <>
                      {state.NumberCounts.Editable == 2 ||
                        state.ClientBranchIDs.SUBROLE == 3 ? (
                        <>
                          <div className="row">
                            <div className="col-6">
                              <label class="form-label-Header">
                                Photo of Aadhaar card
                              </label>
                              <span style={{ color: "red" }}>*</span>

                            </div>
                            <div className="col-6">
                              <label class="form-label-Header">
                                Photo of PAN card
                              </label>



                            </div>
                            <div className="col-12">
                              <div className="row AAdharImages">
                                <div className="col-6 ImageAadharForm">
                                  <div className="col-md-6 p-0">

                                    {/* -------------ID----verifications---------fronts------------------ */}
                                    <div
                                      class="col-6 p-0"
                                    >
                                      <>
                                        {data.aadharfront_id ? (
                                          <img
                                            src={data.aadharfront_id}
                                            onClick={(e) => {
                                              if (state.NumberCounts.Editable == 1) {

                                                window.open(data.aadharfront_id);
                                              }
                                            }}
                                            className="pointer"
                                            style={{
                                              height: "153px",
                                              width: "198px",
                                              margin: "13px 25px 21px 0px",

                                              border: "4px solid #234492",
                                              borderRadius: "12px",
                                              marginRight: "25",
                                            }}
                                            alt="Image"
                                          />
                                        ) : (
                                          <p
                                            style={{
                                              margin: 0,
                                              padding: 10,
                                              width: "200px",
                                            }}
                                          >
                                            AAdhar Frontside Image
                                          </p>
                                        )}

                                        <Downloads_doc url={data.aadharfront_id} />

                                      </>
                                    </div>

                                    <p
                                      className="Error"
                                      style={{ marginLeft: "-5px" }}
                                    >
                                      {AadhaFronErr}
                                    </p>
                                    {/* </div> */}
                                  </div>
                                  <div className="col-md-6 p-0">
                                    <div
                                      class="col-6 p-0"

                                    >
                                      <>
                                        {urlsign ? (
                                          <img
                                            src={urlsign}
                                            onClick={(e) => {
                                              if (state.NumberCounts.Editable == 1) {

                                                window.open(urlsign);
                                              }
                                            }}
                                            className="pointer"
                                            style={{
                                              height: "153px",
                                              width: "198px",
                                              margin: "13px 25px 21px 0px",
                                              borderRadius: "12px",

                                              border: "4px solid #234492",

                                              marginRight: "25",
                                            }}
                                            alt="Image"
                                          />
                                        ) : (
                                          <p
                                            style={{
                                              margin: 0,
                                              padding: 10,
                                              width: "200px",
                                            }}
                                          >
                                            Aadhaar Backside image
                                          </p>
                                        )}
                                        <Downloads_doc url={urlsign} />

                                      </>
                                    </div>

                                    <p
                                      className="Error"
                                      style={{ marginLeft: "-5px" }}
                                    >
                                      {AAdhaBackERR}
                                    </p>
                                  </div>
                                </div>

                                <div className="col-6 ImageAadharForm">
                                  <div className="col-md-6">

                                    <div
                                      class="col-12 mt-4"

                                    >
                                      <>
                                        {urlpan ? (
                                          <img
                                            src={urlpan}
                                            onClick={(e) => {
                                              if (state.NumberCounts.Editable == 1) {

                                                window.open(urlpan);
                                              }
                                            }}
                                            className="pointer"
                                            style={{
                                              height: "153px",
                                              width: "198px",
                                              margin: "13px 25px 21px 0px",

                                              border: "4px solid #234492",
                                              borderRadius: "12px",
                                              marginRight: "25",
                                            }}
                                            alt="Image"
                                          />
                                        ) : (
                                          <p
                                            style={{
                                              margin: 0,
                                              padding: 10,
                                              width: "200px",
                                            }}
                                          ></p>
                                        )}

                                        {!urlpan ? (
                                          <Button
                                            className="btn doctorupload doctorupload"
                                            variant="contained"
                                            component="label"
                                            style={{
                                              background: "#234492",
                                              color: "white",
                                              fontSize: "11px !important"

                                            }}
                                            disabled={
                                              state.NumberCounts.Editable ==
                                                1 &&
                                                state.ClientBranchIDs.SUBROLE != 3
                                                ? true
                                                : false
                                            }
                                          >
                                            <input
                                              type="file"
                                              hidden
                                              accept="image/png, image/jpeg"
                                              onChange={(e) => handleFiles3(e)}
                                              ref={fileInputRef}

                                            />
                                            Upload Image
                                          </Button>
                                        ) : (
                                          <></>
                                        )}

                                        {urlpan ? (
                                          <div className="w-100 d-flex " style={{ gap: "12px" }}>
                                            <Button
                                              className="btn remove doctorupload"
                                              variant="contained"
                                              onClick={(e) => cancel3(e)}
                                              style={{
                                                background: "#234492",
                                                color: "white",
                                                fontSize: "11px !important"

                                              }}

                                            >
                                              Remove Image
                                            </Button>

                                            <Downloads_doc url={urlpan} />
                                          </div>
                                        ) : (
                                          ""
                                        )}
                                      </>
                                    </div>


                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      ) : null}
                    </>
                    <div className="col-12 mt-4 mb-2 p-0">
                      <div>
                        <span style={{ color: "#234492", fontWeight: "550", fontSize: "17px" }}>Police Verification Details</span>
                        <small
                          style={{
                            color: "red",
                            marginTop: "12px",
                            display: "block",
                          }}
                        >
                          Note:Upload the  Police Verification Document, please.
                          Verify that the file is in the JPG, JPEG, or
                          PNG format and that its size is less than 10 MB.
                        </small>
                      </div>

                      <div className="row mt-3" style={{ marginLeft: "0" }}>
                        {/* 📄 Document Upload */}
                        <div className="col-4 p-0">
                          <label className="form-label">
                            Police Verification Document
                            {police_verfiy.is_police_verification == true && (
                              <span style={{ color: "red" }}>*</span>
                            )}
                          </label>
                          <div
                            class="col-6 p-0"

                          >
                            <>
                              {url_police ? (
                                <img
                                  src={url_police}
                                  onClick={(e) => {
                                    if (state.NumberCounts.Editable == 1) {

                                      window.open(url_police);
                                    }
                                  }}
                                  className="pointer"
                                  style={{
                                    height: "153px",
                                    width: "198px",
                                    margin: "13px 25px 21px 0px",

                                    border: "4px solid #234492",
                                    borderRadius: "12px",
                                    marginRight: "25",
                                  }}
                                  alt="Image"
                                />
                              ) : (
                                <p
                                  style={{
                                    margin: 0,
                                    padding: 10,
                                    width: "200px",
                                  }}
                                ></p>
                              )}

                              {!url_police ? (
                                <Button
                                  className="btn doctorupload doctorupload"
                                  variant="contained"
                                  component="label"
                                  style={{
                                    background: "#234492",
                                    color: "white",
                                    fontSize: "11px !important"

                                  }}
                                  disabled={
                                    state.NumberCounts.Editable ==
                                      1 &&
                                      state.ClientBranchIDs.SUBROLE != 3
                                      ? true
                                      : false
                                  }
                                >
                                  <input
                                    type="file"
                                    hidden
                                    accept="image/png, image/jpeg"
                                    onChange={(e) => handleFiles(e)}
                                    ref={fileInputRef_police}

                                  />
                                  Upload Image
                                </Button>
                              ) : (
                                <></>
                              )}

                              {url_police ? (
                                <div className="w-100 d-flex " style={{ gap: "12px", flexDirection: "column", }}>

                                  <Button
                                    className="btn remove doctorupload"
                                    variant="contained"
                                    onClick={(e) => {

                                      setpolice_docfileurl({
                                        ...police_docfirlurl,
                                        police_doc_url: ""

                                      })

                                      steurl_police("")
                                      setpolicedoc(false);
                                      setPresentUrls(prevUrls => {
                                        const updatedUrls = [...prevUrls];
                                        updatedUrls[1] = null;
                                        return updatedUrls;
                                      });
                                    }}
                                    disabled={state.NumberCounts.EmployeeFormFIll == true ? false :
                                      state.NumberCounts.EmployeeFormFIll == false &&
                                        state.ClientBranchIDs.SUBROLE == 3 ? false : true
                                    }


                                    style={{
                                      background: "#234492",
                                      color: "white",
                                      fontSize: "11px !important",
                                      width: "fit-content"

                                    }}

                                  >
                                    Remove Image
                                  </Button>
                                  <Downloads_doc url={url_police} />

                                </div>
                              ) : (
                                ""
                              )}
                            </>
                          </div>
                          {Police_doc_err && <p className="Error mt-2 mb-1">{Police_doc_err}</p>}
                        </div>

                        {/* 📝 Remarks */}
                        <div className="col-4">
                          <label className="form-label">
                            Remarks
                            {police_verfiy.is_police_verification == true && (
                              <span style={{ color: "red" }}>*</span>
                            )}
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="police_verify_remarks"
                            value={police_verfiy.police_verify_remarks}
                            onChange={handleChange}
                            placeholder="Enter remarks"
                            autoComplete="off"
                          />
                          {Police_remarkserr && <p className="Error mt-2 mb-1">{Police_remarkserr}</p>}
                        </div>

                        {/* ✅ Checkbox */}
                        <div className="col-4 mt-4">
                          <div className="form-check">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id="is_police_verification"
                              name="is_police_verification"
                              checked={police_verfiy.is_police_verification}
                              onChange={handleChange}
                            />
                            <label className="form-check-label" htmlFor="is_police_verification">
                              Police Verification Completed
                            </label>
                          </div>
                        </div>
                      </div>


                    </div>


                  </div>

                  <>
                    {
                      // state.NumberCounts.Editable == 2 ||
                      // state.ClientBranchIDs.SUBROLE == 3 
                      (state.NumberCounts.Editable == 2 || state.ClientBranchIDs.SUBROLE == 3) && (state.NumberCounts.EmployeeFormFIll == true)

                        ? (
                          <>
                            <div
                              className="RoleButton"
                              style={{
                                display: "flex",
                                gap: "15px",
                                justifyContent: "flex-end",
                                alignItems: "center",
                                padding: "0px 15px",
                                marginBottom: "20px",
                              }}
                            >
                              <button
                                class="btn ButtonCSS"
                                style={{ color: "#ffff", background: "#234492" }}
                                onClick={(e) => {
                                  dispatch(SetActiveTabs(10));
                                }}
                              >
                                Previous
                              </button>

                              <button
                                class="btn ButtonCSS"
                                style={{ color: "#ffff", background: "#234492" }}
                                onClick={(e) => {
                                  HandleNext(e);
                                }}
                              >
                                Save & Continue
                              </button>
                            </div>
                          </>
                        ) :

                        <>

                          {state.NumberCounts.Editable == 1 &&
                            state.SideBarFiles.UserEmailID == "admin@gmail.com" || state.SideBarFiles.UserEmailID == "admin@qpms.in" ?


                            <div
                              className="RoleButton"
                              style={{
                                display: "flex",
                                gap: "15px",
                                justifyContent: "flex-end",
                                alignItems: "center",
                                padding: "0px 15px",
                                marginBottom: "20px",
                              }}
                            >
                              <button
                                class="btn ButtonCSS"
                                style={{ color: "#ffff", background: "#234492" }}
                                onClick={(e) => {
                                  dispatch(SetActiveTabs(10));
                                }}
                              >
                                Previous
                              </button>

                              <button
                                class="btn ButtonCSS"
                                style={{ color: "#ffff", background: "#234492" }}
                                onClick={(e) => {
                                  HandleNext(e);
                                }}
                              >
                                Save & Continue
                              </button>
                            </div>
                            : null}
                        </>



                    }
                  </>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

      {CroppImageView && (
        <ImageCropper
          updateAvatar={updateAvatar}
          selectedImage={CroppImageViewCount == 1 ? police_docFile : pancardFiles}
          getCroppedImg={getCroppedImg}
          closeModal={() => setCroppImageView(false)}
        />
      )}


    </>
  );
};

export default IDverify;
